module.exports = __webpack_public_path__ + "static/media/thumbnail_rumi-ii-handle@3x.01612fd3.jpg";